// 服務類型 - 活動
export const SERVICE_PROMOTION = 1;
// 服務類型 - 網頁
export const SERVICE_ZINES = 2;
// 服務類型 - 表單
export const SERVICE_FORM = 3;
// 服務類型 - 標籤
export const SERVICE_TAG = 4;
